import { useTranslation } from 'react-i18next';

const CheckIcon = ({ isValid }) => (
  <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fillRule="evenodd" clipRule="evenodd" d="M15.5303 4.71967C15.8232 5.01256 15.8232 5.48744 15.5303 5.78033L8.03033 13.2803C7.73744 13.5732 7.26256 13.5732 6.96967 13.2803L3.21967 9.53033C2.92678 9.23744 2.92678 8.76256 3.21967 8.46967C3.51256 8.17678 3.98744 8.17678 4.28033 8.46967L7.5 11.6893L14.4697 4.71967C14.7626 4.42678 15.2374 4.42678 15.5303 4.71967Z" 
      fill={isValid ? "#34c759" : "#AAAAAA"}/>
  </svg>
);

const RequirementItem = ({ isValid, text }) => (
  <div className="justify-center items-center gap-1 flex">
    <div className="relative">
      <CheckIcon isValid={isValid} />
    </div>
    <div className={`text-xs font-normal leading-[18px] ${isValid ? 'text-[#111111]' : 'text-[#aaaaaa]'}`}>
      {text}
    </div>
  </div>
);

const PasswordRequirements = ({ password }) => {
  const { t } = useTranslation();
  
  const requirements = [
    {
      isValid: password.length >= 8 && password.length <= 20,
      text: t('auth.signup.password_requirements.length')
    },
    {
      isValid: /[A-Z]/.test(password),
      text: t('auth.signup.password_requirements.uppercase')
    },
    {
      isValid: /[0-9]/.test(password),
      text: t('auth.signup.password_requirements.number')
    }
  ];

  return (
    <div className="justify-start items-start gap-3 inline-flex">
      {requirements.map((req, index) => (
        <RequirementItem key={index} isValid={req.isValid} text={req.text} />
      ))}
    </div>
  );
};

export default PasswordRequirements; 